export const GET_UPCOMING_BOOKINGS = 'get-upcoming-bookings';
const getUpcomingBookings = ({ fetchAll = false, query = [] }) => ({
  type: GET_UPCOMING_BOOKINGS,
  payload: { fetchAll, query },
});
export default getUpcomingBookings;
